var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.197 17.017C14.034 15.528 12.75 14.369 11.191 14.369H7.468C5.798 14.369 4.444 15.698 4.444 17.337V17.592C3.09214 16.8113 1.96971 15.6883 1.18959 14.3361C0.409481 12.9839 -0.000806809 11.4501 1.19112e-06 9.889C1.19112e-06 4.983 3.973 1 8.88 1C13.795 1 17.778 4.983 17.778 9.889C17.7789 11.2742 17.4555 12.6403 16.8337 13.8781C16.2118 15.1159 15.3089 16.1908 14.197 17.017ZM8.889 6.334C7.94589 6.334 7.04141 6.70864 6.37453 7.37552C5.70765 8.04241 5.333 8.94688 5.333 9.88999C5.333 10.8331 5.70765 11.7376 6.37453 12.4045C7.04141 13.0713 7.94589 13.446 8.889 13.446C9.8321 13.446 10.7366 13.0713 11.4035 12.4045C12.0704 11.7376 12.445 10.8331 12.445 9.88999C12.445 8.94688 12.0704 8.04241 11.4035 7.37552C10.7366 6.70864 9.8321 6.334 8.889 6.334Z",
    fill: "#3860ed"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5742 23.5991V20.0644H14.0117V17.6245H17.5742V14.0898H19.9492V17.6245H23.521V20.0644H19.9492V23.5991H17.5742Z",
    fill: "#3860ed"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAdd);
export default __webpack_public_path__ + "static/media/user_add.f4df2986e9179deda30cb648cadcc65f.svg";
export { ForwardRef as ReactComponent };